export default __webpack_public_path__ + "static/media/BIFI-BNB-banana.814794cd.svg";